import styled from "styled-components";
import {UserMenuSeparatorDefaultBox} from "./user-menu-separator.default.box";

export const UserMenuSeparatorSiBox = styled(UserMenuSeparatorDefaultBox)`
  box-shadow: 0 0.35px 0 0 ${({theme}) => theme.colors.boxBorderLighter};
`